import type { Recording } from "../../api/types";
import { recordingDurationSeconds } from "../../utils";
import { sessionStatus } from "./SessionStatus";

export const sessionStatusIds = [
  "completed",
  "analyzing",
  "not_analyzed",
  "failed",
  "cancelled",
  "not_synced",
  "recording_too_short",
];
export const defaultSessionFilters = {
  query: "",
  status: sessionStatusIds,
  archive: "active",
  min: null as number | null,
  max: null as number | null,
};
export type SessionFilterValues = typeof defaultSessionFilters;
export const sessionFilterCount = (filters: SessionFilterValues) =>
  Number(!!filters.query.trim()) +
  Number(filters.status.length !== sessionStatusIds.length) +
  Number(filters.archive !== "active") +
  Number(filters.min !== null || filters.max !== null);

export function matchesSessionFilters(
  item: Recording,
  filters: SessionFilterValues,
  unnamed: string,
) {
  const seconds = recordingDurationSeconds(item);
  return (
    (item.name || unnamed).toLowerCase().includes(filters.query.trim().toLowerCase()) &&
    filters.status.includes(sessionStatus(item)) &&
    (filters.archive === "all" || item.include_in_processes === (filters.archive === "active")) &&
    (filters.min === null || seconds >= filters.min) &&
    (filters.max === null || seconds <= filters.max)
  );
}
